import { mergeStyles, convertToLocalStyle, glyphIconStyle }
  from '@bingads-webui-campaign-react/common-styles';

const borderWidth = '2px';

const formStyle = ({ palette = {} }) => ({
  '.error': {
    color: '#A80000',
  },

  'input.error, select.error, textarea.error, input.campaign-error-row, select.campaign-error-row, textarea.campaign-error-row': {
    border: '1px solid @input-error-border !important',
    color: palette.neutralPrimary,
  },
});

export const getWizardStyles = (components, theme = {}) => ({
  '@global': {
    ...components.spinnerKeyframe, // FIXME: UINext must load this, or '@bingads-webui-react/ui-blocker' must properly style itself
  },
  hidden: {
    display: 'none',
  },
  show: {
    display: 'flex',
  },
  uiBlockerAdapter: {
    ...mergeStyles(
      { theme },
      components.reactUIBlockerStyle(theme.palette, 'rgba(255, 255, 255, 0.4)'),
      {
        '& .react-block-ui-none, & .react-block-ui': {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          overflowY: 'hidden', // to not extend to the content, but shrink to flex-parent
        },
      },
      {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        overflowY: 'hidden',
      }
    ),
  },
  wizardContainer: {
    ...mergeStyles(
      { theme },
      convertToLocalStyle(components.helpbuttonStyle(theme)),
      convertToLocalStyle(glyphIconStyle(theme)),
      {
        display: 'flex',
        flexGrow: 1,
        overflowY: 'hidden',
      }
    ),
  },
  // StepProgressList on left side
  wizardListContainer: {
    width: '228px',
    minWidth: '228px',
    borderRight: `1px solid ${theme.palette.neutralQuaternaryAlt}`,
    paddingLeft: '32px',
    paddingTop: '32px',
    paddingBottom: '32px',
    overflow: 'hidden auto',

    '& ol': {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },

    // Styles for drawing the vertical line
    '& .step-progress-list-item': {
      borderLeft: `${borderWidth} solid ${theme.palette.blue}`,
      '&.step-progress-list-item-ahead': { borderLeftColor: '#ebebeb' },
    },

    '& .step-progress-list-item-title': {
      position: 'absolute',
      float: 'right',
      maxWidth: 165,
    },

    // top level list items
    '& ol.step-progress-list>.step-progress-list-item': {
      paddingTop: 39,
      position: 'relative',

      '&:first-child': { borderLeftColor: theme.palette.white, paddingTop: 0 },

      '&>.step-progress-list-item-glyphicon': {
        marginLeft: '-8px',
        marginRight: '8px',
        background: theme.palette.white,
        paddingTop: '5px',
        paddingBottom: '4px',
      },

      '&>.step-progress-list-item-glyphicon.iconba-RadioBullet2': {
        paddingTop: 0,
        paddingBottom: 0,
        transform: 'scale(1.52)',
      },
    },

    // nested list items
    '& ol.step-progress-list-item-list>.step-progress-list-item': {
      fontSize: '12px',
      lineHeight: '16px',
      paddingTop: '24px',
      marginLeft: `-${borderWidth}`,

      '&>.step-progress-list-item-glyphicon': {
        marginLeft: '-8px',
        marginRight: '12px',
        white: theme.palette.white,
        paddingBottom: '1px',
      },
    },

    '& .step-progress-list-item-selected, & .step-progress-list-item-contains-selected': { fontWeight: '600' },

    // glyphicon colors
    '& .step-progress-list-item-behind .step-progress-list-item-glyphicon': {
      color: theme.palette.blue,
    },
    '& .step-progress-list-item-selected .step-progress-list-item-glyphicon, & .step-progress-list-item-contains-selected>.step-progress-list-item-glyphicon': {
      color: '#c0def6',
    },
    '& .step-progress-list-item-ahead .step-progress-list-item-glyphicon': {
      color: theme.palette.neutralLight,
    },
  },
  wizardMainContainer: {
    backgroundColor: theme.palette.neutralLighterAlt,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  wizardStepContainer: {
    display: 'flex',
    overflowY: 'auto',
  },
  wizardSingleStepLayoutStepScrollingContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  wizardSingleStepLayoutCenteredStepContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  wizardSingleStepLayoutStepContainer: {
    display: 'flex',
  },
  wizardStep: {
    ...mergeStyles(
      { theme },
      convertToLocalStyle(formStyle(theme)),
      {
        display: 'flex',
        flexBasis: '1px',
        flexDirection: 'column',
        paddingLeft: 32,
        paddingRight: 32,
      }
    ),
  },
  wizardFooter: {
    marginTop: 'auto', // to expand as flex-item
    backgroundColor: theme.palette.white,
  },
  mobileNavContainer: {
    position: 'fixed',
    display: 'none',
    height: 60,
    width: '100%',
    background: theme.palette.white,
    zIndex: 2,
    boxShadow: '0px 3.2px 7.2px rgba(0, 0, 0, 0.132), 0px 0.6px 1.8px rgba(0, 0, 0, 0.108)',
  },
});
